import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "_pt-3 _pb-3 _px-3 _tal" }
const _hoisted_2 = {
  key: 0,
  class: "_flexwrap _mt-2 _mb-3"
}
const _hoisted_3 = { class: "_ttl" }
const _hoisted_4 = { class: "_flex _ai-c _jc-fe _pa-2" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_option_field = _resolveComponent("option-field")
  const _component_multi_checkbox_field = _resolveComponent("multi-checkbox-field")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_button = _resolveComponent("base-button")
  const _component_checkbox_field = _resolveComponent("checkbox-field")
  const _component_drawer = _resolveComponent("drawer")
  const _component_project_test_model_phase_changed_warning_modal = _resolveComponent("project-test-model-phase-changed-warning-modal")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_drawer, {
      "is-open": $props.isDrawerOpen,
      onClose: $options.onCancel
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "_tc--accent _ttl _px-0",
            onClick: _cache[3] || (_cache[3] = (...args) => ($options.onCancel && $options.onCancel(...args))),
            "data-qa": "adjust-preview:Cancel"
          }, "Cancel"),
          _createVNode(_component_base_button, {
            class: "_ml-3",
            theme: "accent",
            width: "compact",
            onClick: $options.onSubmit,
            "data-qa": "adjust-preview:Apply"
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createTextVNode(" Apply ", -1 /* CACHED */)
            ]))]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "gfu-hd gfu-hd--h1 _mb-3" }, "Adjust preview", -1 /* CACHED */)),
          _createVNode(_component_option_field, {
            modelValue: _ctx.model.projectPhase,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.model.projectPhase) = $event)),
            options: $options.projectPhaseOptions,
            "read-only": $options.projectPhaseIsReadOnly,
            "display-name": "Project phase",
            description: "You will see the project as if it were in the selected phase.",
            class: "_mb-3",
            "data-qa": "adjust-preview:ProjectPhase"
          }, null, 8 /* PROPS */, ["modelValue", "options", "read-only"]),
          _createVNode(_component_multi_checkbox_field, {
            modelValue: _ctx.model.userGroupIDs,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.model.userGroupIDs) = $event)),
            options: $options.userGroupsOptions,
            "read-only": $options.userGroupsIsReadOnly,
            placeholder: $options.userGroupsIsReadOnly ? 'No user groups available' : 'Please select...',
            "no-option-capitalize": true,
            "display-name": "User groups",
            description: "You will see the project as if you were a member of the selected user groups.",
            class: "_mb-3",
            "data-qa": "adjust-preview:UserGroups"
          }, null, 8 /* PROPS */, ["modelValue", "options", "read-only", "placeholder"]),
          ($options.selectedUserGroupsNames.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.selectedUserGroupsNames, ({value, label}) => {
                  return (_openBlock(), _createBlock(_component_base_button, {
                    key: value,
                    class: "_mr-1 _mb-1",
                    width: "compact",
                    theme: "searchSecondary",
                    onClick: $event => ($options.onCategoryDelete(value))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("strong", _hoisted_3, _toDisplayString(label), 1 /* TEXT */),
                      _createVNode(_component_base_icon, {
                        name: "window-close",
                        class: "_ml-1"
                      })
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true),
          _cache[6] || (_cache[6] = _createElementVNode("h4", { class: "gfu-hd gfu-hd--h4 _tc--base" }, "Content visibility options", -1 /* CACHED */)),
          _createVNode(_component_checkbox_field, {
            modelValue: _ctx.model.showUnpublishedContent,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.model.showUnpublishedContent) = $event)),
            class: "_mt-0",
            condensed: true,
            "data-qa": "adjust-preview:ShowUnpublishedContent"
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode(" show unpublished content ", -1 /* CACHED */)
            ]))]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["modelValue"])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["is-open", "onClose"]),
    _createVNode(_component_project_test_model_phase_changed_warning_modal, {
      "is-modal-visible": _ctx.isProjectTestModelPhaseChangedWarningModalVisible,
      onClose: $options.onModalClose,
      onContinue: $options.toggleTestingMode
    }, null, 8 /* PROPS */, ["is-modal-visible", "onClose", "onContinue"])
  ]))
}